import { SUPPORT_SETTINGS_SECTOR_ALIAS } from '../../constants/_core/support-settings-sector-alias';

export const EVENT_NAME = 'FLOATING_SUPPORT_EVENT';
const supportSettingSectorAliasList = Object.values(SUPPORT_SETTINGS_SECTOR_ALIAS);

const show = ({ supportSettingSectorAlias }) => {
  if (!supportSettingSectorAlias) {
    console.error('Support settings: supportSettingSectorAlias is required.');
    return;
  }

  if (!supportSettingSectorAliasList.includes(supportSettingSectorAlias)) {
    console.error(`Support settings: supportSettingSectorAlias must be ${supportSettingSectorAliasList.join(', ')}.`);
    return;
  }

  dispatchEvent(new CustomEvent(EVENT_NAME, {
    detail: {
      supportSettingSectorAlias
    }
  }));
};

const hide = () => {
  dispatchEvent(new CustomEvent(EVENT_NAME, {
    detail: { supportSettingSectorAlias: null }
  }));
};

export const FloatingSupportDispatcher = {
  show,
  hide
};

export const FloatingSupportListener = {
  addEventListener: (handle) => {
    addEventListener(EVENT_NAME, handle);
  },
  removeEventListener: (handle) => {
    removeEventListener(EVENT_NAME, handle);
  }
};
